import { render, staticRenderFns } from "./the-course.vue?vue&type=template&id=040a575a"
import script from "./the-course.vue?vue&type=script&lang=js"
export * from "./the-course.vue?vue&type=script&lang=js"
import style0 from "./the-course.vue?vue&type=style&index=0&id=040a575a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports